import React from 'react';
import { Switch, Route, Redirect } from "react-router-dom";

// core components/views for Admin layout
import LoginPage from "views/Login/Login.js"

import useAuth from 'hooks/useAuth';

// core components
import Admin from "layouts/Admin.js";
import Operator from "layouts/Operator.js";
import Deliveryman from "layouts/Deliveryman.js";
import Sellsman from "layouts/Sellsman.js";

const Routes = () => {
    const { storageUserType } = useAuth();

    return (

        <Switch >
            <Route path="/login" component={LoginPage} />

            {storageUserType === "admin" && <Admin />}
            {storageUserType === "operator" && <Operator />}
            {storageUserType === "deliveryman" && <Deliveryman />}
            {storageUserType === "sellsman" && <Sellsman />}

            <Redirect from="*" to="/login" />
        </Switch>

    )
};

export default Routes;